import { useId } from 'react';

export default function CollapsibleEditorCard({ title, subtitle, collapsed, onToggle, controls, children }) {
  const contentId = useId();

  return (
    <div className="bg-white rounded-xl border border-amber-100 shadow-sm p-5 sm:p-6">
      <div className="flex items-start justify-between gap-3">
        <h3 className="min-w-0 flex-1">
          <button
            type="button"
            aria-expanded={!collapsed}
            aria-controls={contentId}
            aria-label={`${collapsed ? 'Expand' : 'Collapse'} ${title}`}
            onClick={onToggle}
            className="flex w-full items-start gap-2 text-left text-amber-800 hover:text-amber-600 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400"
          >
            <span aria-hidden="true" className="mt-1">{collapsed ? '▸' : '▾'}</span>
            <span className="min-w-0">
              <span className="block font-semibold text-lg break-words">{title}</span>
              {subtitle && <span className="block text-xs font-normal text-amber-500 mt-1">{subtitle}</span>}
            </span>
          </button>
        </h3>
        {controls}
      </div>
      {/* Keep editors mounted so collapsing preserves drafts and input values. */}
      <div id={contentId} hidden={collapsed}>
        <div className="mt-4 space-y-5">{children}</div>
      </div>
    </div>
  );
}
